import { memo } from 'react';
import PropTypes from 'prop-types';
// Import components
import CampaignGeneralDetails from './CampaignGeneralDetails';
import CampaignActivity from './CampaignActivity';

const CampaignReportDetails = (props) => {
    const {
        isLoadingExecutionResults,
        campaignData,
        executionResults,
        executionResultsCount,
        templateData,
        segmentData,
        schedule,
        bonus,
        goal,
        hasGoal,
        campaignId,
        onDateTimeApply,
        onReloadExecutionResults,
        recurrenceData,
        handleChangePageNumber,
        handleChangePageSize,
        handleChangeSorting,
    } = props;

    return (
        <div className="details-page-wrapper">
            <div className="details-page-wrapper-inner">
                <div className="campaign-general-details">
                    <CampaignGeneralDetails
                        campaignData={campaignData}
                        templateData={templateData}
                        segmentData={segmentData}
                        schedule={schedule}
                        bonus={bonus}
                        goal={goal}
                        hasGoal={hasGoal}
                        recurrenceData={recurrenceData}
                    />
                </div>
                <div className="campaign-activity">
                    <CampaignActivity
                        isLoadingExecutionResults={isLoadingExecutionResults}
                        campaignId={campaignId}
                        data={executionResults}
                        segmentData={segmentData}
                        count={executionResultsCount}
                        name={campaignData?.Name?.Name}
                        onDateTimeApply={onDateTimeApply}
                        onReloadExecutionResults={onReloadExecutionResults}
                        handleChangePageNumber={handleChangePageNumber}
                        handleChangePageSize={handleChangePageSize}
                        handleChangeSorting={handleChangeSorting}
                    />
                </div>
            </div>
        </div>
    );
};

CampaignReportDetails.propTypes = {
    isLoadingExecutionResults: PropTypes.bool.isRequired,
    campaignId: PropTypes.string.isRequired,
    schedule: PropTypes.object,
    segmentData: PropTypes.object,
    executionResults: PropTypes.array.isRequired,
    executionResultsCount: PropTypes.number.isRequired,
    campaignData: PropTypes.object,
    templateData: PropTypes.object,
    bonus: PropTypes.object,
    goal: PropTypes.object.isRequired,
    hasGoal: PropTypes.bool.isRequired,
    onDateTimeApply: PropTypes.func,
    onReloadExecutionResults: PropTypes.func,
    recurrenceData: PropTypes.object,
    handleChangePageNumber: PropTypes.func,
    handleChangePageSize: PropTypes.func,
    handleChangeSorting: PropTypes.func,
};

export default memo(CampaignReportDetails);
